import { UserProfile, getOperatingDate, getUTCOperatingBoundaryDatetimes, loadExtraMomentLocales } from '@liquitics/transaction';
import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TenantInfo } from './tenant/tenant-info';
import * as moment from 'moment';

@Injectable()
export class AppConfig {
    private useJSONData: boolean;
    private tenantInfo: TenantInfo;
    private todayString: string;
    private todayStartUTC: moment.Moment;
    private startOfDayDatetimeUTC: moment.Moment;
    private endOfDayDatetimeUTC: moment.Moment;
    asOfDateMode = false;
    asOfDatetimeUTC: moment.Moment;
    activeUserProfile: UserProfile;

    showApplicationIdentifiers: boolean;
    applicationIdentificationDescription: string;
    applicationIdentificationColorIndex: number;

    constructor(private http: HttpClient) {

    }

    public getTenantInfo(): TenantInfo {
        return this.tenantInfo;
    }

    public getTodayString(): string {
        return this.todayString;
    }

    public getTodayStartUTC(): moment.Moment {
        return this.todayStartUTC.clone();
    }

    public getStartOfDayDatetimeUTC(): moment.Moment {
        return this.startOfDayDatetimeUTC;
    }

    public getEndOfDayDatetimeUTC(): moment.Moment {
        return this.endOfDayDatetimeUTC;
    }

    // Call with care. Make sure to handle service reloading
    // when value has already been read and cached
    public setTodayStartUTC(newStartUTC: moment.Moment) {
        this.todayString = getOperatingDate(newStartUTC.clone().utc().subtract(this.tenantInfo.postEndOfDayHours, 'hours'),
            this.tenantInfo.utcOffset, this.tenantInfo.utcEndOfDayHour);
        this.onTodaySet();
    }

    private onTodaySet() {
        this.todayStartUTC = moment.utc(this.todayString);
        const operatingDateBoundaries = getUTCOperatingBoundaryDatetimes(this.todayString,
            this.getTenantInfo().utcOffset, this.getTenantInfo().utcEndOfDayHour);
        this.startOfDayDatetimeUTC = moment.utc(operatingDateBoundaries[0]);
        this.endOfDayDatetimeUTC = moment.utc(operatingDateBoundaries[1]);
    }

    private extractTenantId(info: TenantInfo): string {
        let id: string;
        if (info.adminApplicationUrl) {
            // adminApplicationUrl: "https://development.reference.liquitics.com"

            let splits = info.adminApplicationUrl.split('/');
            splits = splits[splits.length - 1].split('.');
            id = splits[0];
        } else if (info.cognitoDomainPrefix) {
            let splits = info.cognitoDomainPrefix.split('-');
            id = splits[0];
        }
        return id;
    }

    public load(): Promise<TenantInfo> {
        const thisAppConfig = this;
        loadExtraMomentLocales(moment);
        // moment.locale('en-in', {
        //     parentLocale: 'en-gb'
        // });
        return this.http.get('assets/tenant.json').toPromise()
            .then(data => {
                const json: any = data;
                const info = new TenantInfo();
                info.region = json.region;
                info.identityPoolId = json.identityPoolId;
                info.userPoolId = json.userPoolId;
                info.clientId = json.clientId;
                info.cognitoDomainPrefix = json.cognitoDomainPrefix;
                info.apiUrl = json.apiUrl;
                info.bucket = json.bucket;
                info.utcOffset = json.utcOffset;
                info.utcEndOfDayHour = json.utcEndOfDayHour;
                info.postEndOfDayHours = json.postEndOfDayHours;
                info.adminApplicationUrl = json.adminApplicationUrl;
                info.tenantId = this.extractTenantId(info);
                thisAppConfig.tenantInfo = info;
                this.setToLiveOperatingDate();
                this.useJSONData = json.useJSONData;
                return info;
            });
    }

    public setToLiveOperatingDate() {
        const operatingDate: string = getOperatingDate(moment().utc().subtract(this.tenantInfo.postEndOfDayHours, 'hours'),
            this.tenantInfo.utcOffset, this.tenantInfo.utcEndOfDayHour);
        // TEMP
        // todayLocal.subtract(1, 'day');
        this.todayString = operatingDate;
        this.onTodaySet();
    }

    public getUseJSONData(): boolean {
        return this.useJSONData;
    }
}
